import { GridSortModel } from '@mui/x-data-grid';
import { TEntityListResponse, TDeviceSummaryResBody } from '@poseidon-city/api-sdk';
import { useQuery } from '@tanstack/react-query';
import { stringify } from 'qs';

import { useApiSDK } from '../../contexts/apiSdkContext';
import { useCompanyId } from '../../contexts/CompaniesAreasContext';

type TDeviceByDeviceTypeListHook = {
  isError: boolean;
  isLoading: boolean;
  data: TEntityListResponse<'device', TDeviceSummaryResBody> | undefined | null;
};

const getQuerySortString = (queryOptions?: { sortModel: GridSortModel }): string => {
  if (queryOptions && queryOptions.sortModel.length > 0) {
    return `&sort[${queryOptions.sortModel[0].field}]=${queryOptions.sortModel[0].sort}`;
  }
  return '';
};

function useGetDevicesByDeviceType(
  limit: number,
  page: number,
  deviceTypeId: string,
  queryOptions?: { sortModel: GridSortModel },
  areaId?: string
): TDeviceByDeviceTypeListHook {
  const sdk = useApiSDK();
  const { companyId } = useCompanyId();

  let filterStr: string;
  if (areaId && areaId !== 'ALL') {
    const filter = { filter: { area_id: areaId } };
    filterStr = stringify(filter);
  } else if (companyId && companyId.id !== 'ALL') {
    const filter = { filter: { company_id: companyId.id } };
    filterStr = stringify(filter);
  }

  const sortStr = getQuerySortString(queryOptions);

  const { isError, isLoading, data } = useQuery({
    queryKey: ['device-by-device-type', deviceTypeId, areaId, companyId ? companyId.id : 'ALL', page, limit, sortStr],
    queryFn: async () => {
      if (areaId && filterStr) {
        const data = await sdk.deviceTypes.list_device_type_devices(limit, page, deviceTypeId, filterStr, sortStr);
        return data;
      } else {
        if (companyId && companyId.id === 'ALL') {
          const data = await sdk.deviceTypes.list_all_devices_by_type_devices(limit, page, deviceTypeId, sortStr);
          return data;
        } else if (companyId && companyId.id !== 'ALL') {
          const data = await sdk.deviceTypes.list_device_type_devices(limit, page, deviceTypeId, filterStr, sortStr);
          return data;
        } else {
          return null;
        }
      }
    },
    cacheTime: 0,
    staleTime: 0,
  });

  return { isError, isLoading, data };
}

export { useGetDevicesByDeviceType, getQuerySortString };
